

type ConvertToPngOptions = {
    width?: number;
};

async function convertToPng(blobUrl: string, options: ConvertToPngOptions = { width: 8000 }): Promise<Blob | null> {
    const img = new Image();
    const width = options.width || 8000;

    return new Promise<Blob | null>((resolve, reject) => {
        img.onload = () => {

            const aspectRatio = img.height / img.width;
            const height = width * aspectRatio;


            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;

            const context = canvas.getContext('2d');
            if (context) {

                context.drawImage(img, 0, 0, width, height);


                canvas.toBlob((blob) => {
                    if (blob) {
                        resolve(blob);
                    } else {
                        reject(new Error("Failed to convert the canvas to PNG."));
                    }
                }, 'image/png');
            } else {
                reject(new Error("Unable to get the canvas context."));
            }
        };

        img.onerror = () => {
            reject(new Error("Failed to load the image from the provided Blob URL."));
        };


        img.crossOrigin = 'anonymous';
        img.src = blobUrl;
    });
}
export default convertToPng;
